export default __webpack_public_path__ + "657feab9d5e586ef32324bf256e06117.svg";